
/**
 * Station data should consist of the following format
 * {
 *  HistoricForecast: [
 *      {
 *          DewPoint: null
 *          Gust: null
 *          Humidity: number
 *          IsForecast: boolean
 *          IsWindCalculated: boolean
 *          Rainfall10AM: null
 *          Rainfall9AM: null
 *          StationDateTicks: number
 *          StationDateTime: string
 *          StationId: number
 *          StationName: string
 *          Temperature: number
 *          WeatherObservationId: number
 *          WindDirDeg: number
 *          WindDirection: string
 *          WindSpeed: number
 *          wind_src: null
 *      }
 *  ],
 *  Observations: [
 *      {
 *          DewPoint: number,
 *          Gust: null,
 *          Humidity: number,
 *          IsForecast: boolean,
 *          IsWindCalculated: boolean,
 *          Rainfall10AM: number
 *          Rainfall9AM: number,
 *          StationDateTicks: number,
 *          StationDateTime: string,
 *          StationId: number,
 *          StationName: string,
 *          Temperature: number,
 *          WeatherObservationId: number,
 *          WindDirDeg: null,
 *          WindDirection: null,
 *          WindSpeed: null,
 *          wind_src
 *      }
 *  ],
 *  StationInfo: {
 *      CsDashboardId: null,
 *      DeploymentStatus: null,
 *      Description: string,
 *      Elevation: number,
 *      FTSID: null,
 *      ForecastDistrictId: string,
 *      FunctionalStatus: null,
 *      InList: null,
 *      JurisdictionId: number,
 *      JurisdictionName: string,
 *      Latitiude: string,
 *      LinkUrl: string,
 *      Longitude: number,
 *      StationAnemometerHeight: null,
 *      StationName: string,
 *      StationNumber: string,
 *      StreetAddress: null,
 *      Tz: string,
 *      UnitType: string,
 *      WMOID: number,
 *      WarningValid: null,
 *      WeatherStationId: number
 *  }
 * }
 * @param {*} detailsContainer 
 * @param {*} stationData 
 */
export function drawStationDataGrid(detailsContainer, stationData) {
    // Create the four data grids
    const dataGridCSS = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `100px`,
        height: `100px`,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '4px',
        borderColor: `black`,
        flexDirection: 'column',
        padding: '4px'
    }

    const gridItemHeaderCSS = {
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }

    const gridItemValueCSS = {
        fontWeight: '500',
        fontSize: '36px'
    }

    function gridItemGenerator(bootstrapIconHtmlStr, iconMarginLeft, headerText, valueText) {
        const gridItem = $(`<div></div>`);
        const gridItemHeader = $(`<div>` + 
                `${bootstrapIconHtmlStr} <div style="margin-left:${iconMarginLeft}px">${headerText}</div>` +
            `</div>`);
        gridItemHeader.css(gridItemHeaderCSS);
        const gridItemValue = $(`<h1>${valueText}</h1>`);
        gridItemValue.css(gridItemValueCSS);
        gridItem.append(gridItemHeader, gridItemValue);
        gridItem.css(dataGridCSS);

        return gridItem;
    }

    // 1. Temperature
    const tempGridItem = gridItemGenerator(
        '<i class="bi bi-thermometer-half" style="font-size:20px"></i>',
        2,
        'Temperature ( <sup>o</sup>C )',
        stationData['Observations'].at(-1)['Temperature']);

    // 2. Humidity
    const humidityGridItem = gridItemGenerator(
        '<i class="bi bi-moisture" style="font-size:20px"></i>',
        4,
        'Humidity (%)',
        stationData['Observations'].at(-1)['Humidity']);
    
    // 3. Wind speed
    const windSpdGridItem = gridItemGenerator(
        '<i class="bi bi-wind" style="font-size:20px"></i>',
        4,
        'Wind Speed (km/h)',
        stationData['Observations'].at(-1)['WindSpeed']);

    // 4. Wind Direction

    let rotation = -45;
    rotation += +stationData['Observations'].at(-1)['WindDirDeg']
    rotation += 180
    rotation %= 360 

    const windDirGridItem = gridItemGenerator(
        `<i class="bi bi-cursor-fill" style="font-size:20px;transform:rotate(${rotation}deg);"></i>`,
        4,
        'Wind Direction',
        stationData['Observations'].at(-1)['WindDirection']
    )

    const gridContainer = $(`<div></div>`);
    const gridRowTopContainer = $(`<div></div>`);
    const gridRowBottomContainer = $(`<div></div>`);

    const gridRowCSS = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px',
        width: '100%'
    };

    gridContainer.css({
        width: '100%'
    });

    gridRowTopContainer.css(gridRowCSS);
    gridRowBottomContainer.css(gridRowCSS);

    gridRowTopContainer.append(tempGridItem, humidityGridItem, windSpdGridItem, windDirGridItem);
    // gridRowBottomContainer.append(windSpdGridItem, windDirGridItem);
    gridRowBottomContainer.css({
        marginTop: '30px'
    })
    gridContainer.append(gridRowTopContainer);

    detailsContainer.append(gridContainer);
}